// Import polyfills first
import './utils/polyfills';

import { BrowserRouter } from 'react-router-dom';
import React, { StrictMode } from 'react';
import * as Sentry from '@sentry/react';
import { env } from 'constants';
import ConfigProvider from 'components/ConfigProvider';
import { ExtraErrorData } from '@sentry/integrations';
import { loadGTM } from 'utils/script';
import { unregister } from 'serviceWorkerRegistration';
import App from 'App';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <StrictMode>
    <ConfigProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </StrictMode>,
);

initializeScripts();

const { documentElement } = document;
// add CSS variables so we can read them back
documentElement.style.setProperty('--gap-top', 'calc(env(safe-area-inset-top,0) / 1.2)');
documentElement.style.setProperty('--gap-bottom', 'calc(env(safe-area-inset-bottom) / 1.3)');

function initializeScripts() {
  if (env.SENTRY_DSN) {
    Sentry.init({
      dsn: env.SENTRY_DSN,
      environment: env.APP_ENV,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      integrations: [new ExtraErrorData({ depth: 4 }), new Sentry.Replay()],
    });
  }
  if (env.GTM_ID) {
    loadGTM(env.GTM_ID);
  }
}

unregister();
